<template>
  <div class="head_cart ease" id="head_cart" :class="{hide: ($store.state.permOrderEdit && $route.name == 'permenent') ||  $route.name == 'permenent'}">
    <a href="javascript:void(0);"  onclick="openCart();">
      <CART />
      <span class="cart_num ease">{{ productsInCart }}</span>
    </a>
  </div>
</template>
<script>
import CART from "../../assets/img/cart2.svg";
import Vuex from "vuex";
export default {
  computed: {
    ...Vuex.mapGetters({
      productsInCart: "getNumberOfProducts",
    })
  },
  methods:{

  },
  components: {
    CART
  }
};
</script>
